<div class="row line-bottom" style="margin-bottom: 10px;" *ngIf="title">
    <div class="col-md-6" >
     <h4 class="title-page">
      {{ title }}  
    </h4>
    </div>
    <!-- <div class="col-md-6" style="text-align: right;">2</div> -->
  </div>